import React, { useState, useEffect } from 'react'

/**
 * Pardotが生成するフォームのオリジン
 */
const PARDOT_FORM_ORIGIN = 'https://go.commmune.jp'

/**
 * Pardotフォーム
 * NOTE: Pardotの管理画面で出力されたiframeをスタイル等を修正して添付
 * 参考：
 *  https://www.salesforceben.com/the-drip/embed-pardot-forms-on-your-website-using-iframe/
 *  https://www.notion.so/commmune/Pardot-81e3b83eccfb4ee688d60dafa59ed595
 */
const PardotForm = (props) => {
  // NOTE: 500はPardotでiframeのコードを生成した場合に設定されるデフォルト値のため、一旦そのまま利用する
  const [height, setHeight] = useState(500)

  /**
   * iframe内のコンテンツからのメッセージを受け取り、iframeの高さを設定する
   * NOTE: 運用都合でフォームの高さが変わる可能性があるので、呼び出し側で制限しない
   */
  const receiveMessage = (event) => {
    // メッセージの送信元がPardotで生成されたフォームかどうかを判断する
    if (event.origin === PARDOT_FORM_ORIGIN) {
      // iframe内部のコンテンツ+reCAPTCHAの高さをiframeの高さに設定する
      // NOTE: Pardotの機能でreCAPTCHAを生成しているが、これもiframeなので高さが取れない
      const iframeContentHeight = event.data
      const reCaptchaMarginHeight = 16
      const reCaptchaBodyHeight = 78
      const height =
        iframeContentHeight + reCaptchaMarginHeight + reCaptchaBodyHeight

      // 静的ビルドで利用する（CMSから生成した記事を描画する、など）場合はDOMを操作して高さを調整する
      if (props.ssr) {
        document.querySelector('#pardot-form').style.height = `${height}px`
      } else {
        setHeight(height)
      }
    }
  }

  // 静的ビルドで利用する（CMSから生成した記事を描画する、など）場合はuseEffectが動作しないので、直接イベントをアタッチする
  if (props.ssr && typeof window !== 'undefined') {
    window.addEventListener('message', receiveMessage)
  }

  useEffect(() => {
    window.addEventListener('message', receiveMessage)
    return () => window.removeEventListener('message', receiveMessage)
  }, [])

  return (
    <iframe
      id="pardot-form"
      {...{ ...props }}
      width="100%"
      height={height}
      type="text/html"
      frameBorder="0"
    />
  )
}

export default PardotForm
